/* eslint-disable react-hooks/exhaustive-deps */
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import FilterNoneIcon from '@mui/icons-material/FilterNone';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import CloseIcon from '@mui/icons-material/Close';
import { useUnlimitedScroll } from 'src/hooks/useUnlimitedScroll';
import InfiniteScroll from 'react-infinite-scroll-component';
import { IAgeRange } from 'src/models/people';
import { ageRangeList } from 'src/content/streamPanel/peoplePanel/components/SelectAgeRange';

interface ModalSelectAgeProps {
  onClose: (event: {}, reason?: 'backdropClick' | 'escapeKeyDown') => void;
  open: boolean;
  prevSelectedAgeRange?: Array<IAgeRange>;
  onSubmit: (selectedAgeRange: Array<IAgeRange>) => void;
}

const TableCellHeader = styled(TableCell)(
  ({ theme }) => `
        z-index: 3;
        background: ${theme.palette.primary.main};
        color: ${theme.palette.common.white};
    `
);
const ModalSelectAge: React.FC<ModalSelectAgeProps> = ({
  open,
  onClose,
  onSubmit,
  prevSelectedAgeRange = []
}) => {
  const [selectedAgeRangeLocal, setSelectedAgeRangeLocal] =
    useState<Array<IAgeRange>>(prevSelectedAgeRange);
  const theme = useTheme();

  const isSelected = (id: string) =>
    selectedAgeRangeLocal.findIndex((obj) => obj.id === id) !== -1;

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setSelectedAgeRangeLocal(ageRangeList);
      return;
    }
    setSelectedAgeRangeLocal([]);
  };

  const handleClickLabel = function (ageRange: IAgeRange) {
    const selectedIndex = selectedAgeRangeLocal.findIndex(
      (obj) => obj.id === ageRange.id
    );
    let newSelected: IAgeRange[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedAgeRangeLocal, ageRange);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedAgeRangeLocal.slice(1));
    } else if (selectedIndex === selectedAgeRangeLocal.length - 1) {
      newSelected = newSelected.concat(selectedAgeRangeLocal.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedAgeRangeLocal.slice(0, selectedIndex),
        selectedAgeRangeLocal.slice(selectedIndex + 1)
      );
    }
    setSelectedAgeRangeLocal(newSelected);
  };

  const { fetchMoreData, infiniteScroll } =
    useUnlimitedScroll<IAgeRange>(ageRangeList);

  useEffect(() => {
    if (!prevSelectedAgeRange) return;
    setSelectedAgeRangeLocal(prevSelectedAgeRange);
  }, [prevSelectedAgeRange]);

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth={'md'}>
      <DialogTitle
        sx={{
          m: theme.spacing(3, 3, 1)
        }}
      >
        <IconButton
          aria-label="close"
          onClick={(e) => onClose(e)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h3" sx={{ textAlign: 'left' }}>
          Select Age
        </Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          m: theme.spacing(1, 3)
        }}
      >
        <InfiniteScroll
          dataLength={infiniteScroll.list.length}
          next={fetchMoreData}
          hasMore={infiniteScroll.hasMore}
          loader={<div />}
          height={300}
          endMessage={<div />}
        >
          <TableContainer component={Paper}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCellHeader padding="checkbox">
                    <Checkbox
                      indeterminate={
                        selectedAgeRangeLocal.length > 0 &&
                        selectedAgeRangeLocal.length < ageRangeList.length
                      }
                      size="small"
                      sx={{ ml: theme.spacing(0.2) }}
                      icon={
                        <FilterNoneIcon
                          sx={{
                            color: theme.palette.common.white,
                            width: theme.spacing(2.3),
                            height: theme.spacing(2.3)
                          }}
                        />
                      }
                      checkedIcon={
                        <LibraryAddCheckIcon
                          sx={{
                            color: theme.palette.common.white,
                            width: theme.spacing(2.3),
                            height: theme.spacing(2.3)
                          }}
                        />
                      }
                      indeterminateIcon={
                        <IndeterminateCheckBoxIcon
                          sx={{
                            color: theme.palette.common.white,
                            width: theme.spacing(2.2),
                            height: theme.spacing(2.2)
                          }}
                        />
                      }
                      onChange={handleSelectAllClick}
                    />
                  </TableCellHeader>
                  <TableCellHeader align="left" size="small">
                    <Typography
                      variant="subtitle2"
                      sx={{ fontSize: 13, color: theme.palette.common.white }}
                    >
                      Age list
                    </Typography>
                  </TableCellHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {infiniteScroll.list.length > 0 ? (
                  infiniteScroll.list.map((gender) => {
                    const isChecked = isSelected(gender.id);
                    return (
                      <TableRow key={gender.id}>
                        <TableCell align="center" size="small">
                          <FormControlLabel
                            sx={{ marginLeft: 0 }}
                            control={
                              <Checkbox
                                size="small"
                                checked={isChecked}
                                onChange={(e) => {
                                  handleClickLabel(gender);
                                }}
                                name="labels"
                                color="primary"
                                value={gender.id}
                              />
                            }
                            label=""
                          />
                        </TableCell>
                        <TableCell align="left" size="small">
                          {gender.label}
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow hover={false}>
                    <TableCell align="center" colSpan={2}>
                      <Box
                        sx={{
                          width: '100%',
                          height: '100%',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}
                      >
                        <Avatar>N/A</Avatar>
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </InfiniteScroll>
        <Box display="flex" justifyContent="center">
          <Button
            variant="contained"
            size="large"
            onClick={() => onSubmit(selectedAgeRangeLocal)}
            sx={{ width: theme.spacing(20), mt: theme.spacing(2) }}
          >
            Done
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ModalSelectAge;
